(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lofi-country-waitlist-native"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = () => {
      const configNode = document.getElementById('LofiCountryWaitlistNativeConfig');
      const template = document.getElementById('LofiCountryWaitlistNativeTemplate');
      if (!configNode || !template || document.getElementById('LofiCountryWaitlistNative')) return;
      let config;
      try {
        config = JSON.parse(configNode.textContent);
      } catch (_) {
        return;
      }
      if (Number(config.productId) !== 7217112645819) return;

      const delivered = new Set(['US', 'CN', 'FR', 'DE', 'BE', 'NL', 'ES', 'IT', 'PT', 'AT', 'LU', 'IE', 'MT']);
      const actualCountry = String(config.country || '').toUpperCase();
      const availableCountries = new Set(config.countryCodes || []);
      let country = actualCountry;
      if (config.themeRole !== 'main') {
        const parameter = new URLSearchParams(window.location.search).get('lofi_waitlist_preview');
        const simulation = String(parameter || '').toUpperCase();
        if (/^[A-Z]{2}$/.test(simulation) && availableCountries.has(simulation) && !delivered.has(simulation)) country = simulation;
      }
      if (!/^[A-Z]{2}$/.test(country) || delivered.has(country)) return;

      const actions = document.querySelector('.gs-page .gs-hero .gs-actions');
      const purchaseForm = actions && actions.querySelector('form.gs-atc-form');
      if (!actions || !purchaseForm) return;
      const french = String(config.language || '').toLowerCase().startsWith('fr');
      const copy = french ? {
        label: 'Alerte de disponibilité du casque',
        country: 'Livraison indisponible · ',
        loading: 'Chargement du formulaire…',
        failed: 'Le formulaire ne se charge pas. Réessayez pour enregistrer votre demande.',
        retry: 'Réessayer',
        privacy: 'Une alerte pour ce casque uniquement. Aucune inscription à la newsletter.',
        changeCountry: 'Changer le pays de livraison',
        localizationError: 'Utilisez le sélecteur de pays dans le menu de la boutique.',
        sticky: 'Prévenez-moi',
        preview: 'Version test'
      } : {
        label: 'Headphones availability alert',
        country: 'Delivery unavailable · ',
        loading: 'Loading the form…',
        failed: 'The form could not load. Please try again to save your request.',
        retry: 'Try again',
        privacy: 'An update about these headphones only. No newsletter signup.',
        changeCountry: 'Change delivery country',
        localizationError: 'Use the country selector in the store menu.',
        sticky: 'Notify me',
        preview: 'Test version'
      };
      let countryName = country;
      try {
        countryName = new Intl.DisplayNames([french ? 'fr' : 'en'], { type: 'region' }).of(country);
      } catch (_) {
        const index = (config.countryCodes || []).indexOf(country);
        countryName = (config.countryNames || [])[index] || (country === actualCountry ? config.countryName : '') || country;
      }

      const fragment = template.content.cloneNode(true);
      const card = fragment.querySelector('.lofi-waitlist-native');
      const slot = card.querySelector('[data-lwn-slot]');
      const loading = card.querySelector('[data-lwn-loading]');
      const fallback = card.querySelector('[data-lwn-fallback]');
      const retry = card.querySelector('[data-lwn-retry]');
      const changeCountry = card.querySelector('[data-lwn-country-button]');
      card.setAttribute('aria-label', copy.label);
      card.querySelector('[data-lwn-country]').textContent = copy.country + countryName;
      loading.textContent = copy.loading;
      card.querySelector('[data-lwn-fallback-message]').textContent = copy.failed;
      card.querySelector('[data-lwn-privacy]').textContent = copy.privacy;
      retry.textContent = copy.retry;
      changeCountry.textContent = copy.changeCountry;
      if (config.themeRole !== 'main') {
        const badge = card.querySelector('[data-lwn-test]');
        badge.textContent = copy.preview;
        badge.hidden = false;
      }
      retry.addEventListener('click', () => window.location.reload());
      changeCountry.addEventListener('click', () => {
        const opener = Array.from(document.querySelectorAll('modal-opener[aria-controls="Localization-Drawer"]')).find(node => !card.contains(node));
        if (opener) {
          (opener.querySelector('button, a, [role="button"]') || opener).click();
        } else {
          const error = card.querySelector('[data-lwn-localization-error]');
          error.textContent = copy.localizationError;
          error.hidden = false;
        }
      });

      purchaseForm.setAttribute('data-lwn-hidden', 'true');
      const hero = actions.closest('.gs-hero');
      if (hero) hero.setAttribute('data-lwn-active', 'true');
      actions.appendChild(card);

      let appBlock = null;
      let finished = false;
      let intervalId = null;
      let timeoutId = null;
      let observer = null;
      const nativeRoot = () => {
        if (!appBlock) return null;
        const host = appBlock.querySelector('shopify-forms-embed');
        return host && host.shadowRoot;
      };
      const stopWatching = () => {
        if (intervalId !== null) window.clearInterval(intervalId);
        if (timeoutId !== null) window.clearTimeout(timeoutId);
        if (observer) observer.disconnect();
      };
      const inspectNativeForm = () => {
        if (finished) return;
        if (!appBlock) {
          const formRoot = document.querySelector('[data-forms-id="forms-root-1208108"]');
          if (!formRoot || card.contains(formRoot)) return;
          const candidate = formRoot.closest('.shopify-app-block');
          if (!candidate) return;
          const sourceSection = candidate.closest('[id^="shopify-section-"]');
          if (sourceSection && (sourceSection.id.endsWith('__lofi_country_forms') || sourceSection.id === 'shopify-section-lofi_country_forms')) sourceSection.hidden = true;
          appBlock = candidate;
          slot.appendChild(appBlock);
        }
        const root = nativeRoot();
        const nativeForm = root && root.querySelector('form');
        if (!nativeForm || !nativeForm.querySelector('[data-testid="field-email"], input#email, input[type="email"]') || !nativeForm.querySelector('button[type="submit"], input[type="submit"]')) return;
        finished = true;
        loading.hidden = true;
        slot.setAttribute('aria-busy', 'false');
        stopWatching();
        if (['#LofiCountryWaitlistNative', '#LofiCountryWaitlist'].includes(window.location.hash)) {
          window.requestAnimationFrame(() => card.scrollIntoView({ block: 'center' }));
        }
      };
      observer = new MutationObserver(inspectNativeForm);
      observer.observe(document.body, { childList: true, subtree: true });
      intervalId = window.setInterval(inspectNativeForm, 250);
      timeoutId = window.setTimeout(() => {
        if (finished) return;
        finished = true;
        stopWatching();
        loading.hidden = true;
        slot.setAttribute('aria-busy', 'false');
        slot.hidden = true;
        fallback.hidden = false;
      }, 12000);
      inspectNativeForm();

      const sticky = document.querySelector('.gs-sticky-cart');
      const stickyForm = sticky && sticky.querySelector('form.gs-atc-form');
      if (sticky && stickyForm) {
        stickyForm.setAttribute('data-lwn-hidden', 'true');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'lofi-waitlist-native-sticky';
        button.textContent = copy.sticky;
        button.setAttribute('aria-controls', card.id);
        button.addEventListener('click', () => {
          const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          card.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
          const root = nativeRoot();
          const email = !slot.hidden && root && Array.from(root.querySelectorAll('[data-testid="field-email"], input#email, input[type="email"]')).find(input => !input.disabled && input.getAttribute('aria-disabled') !== 'true' && input.getClientRects().length > 0);
          const target = email || (!fallback.hidden ? retry : card);
          target.focus({ preventScroll: true });
        });
        stickyForm.insertAdjacentElement('afterend', button);
      }
      if (['#LofiCountryWaitlistNative', '#LofiCountryWaitlist'].includes(window.location.hash)) window.requestAnimationFrame(() => card.scrollIntoView({ block: 'center' }));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();
  } catch(e) { console.error(e); }
})();

})();
